module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-steps-outer quote-uploads"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "upload-outer"
  }, [_c('parse-to-json', {
    on: {
      "parse-start": _vm.parsing,
      "parse-complete": _vm.parsedForOpti
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.uploads), function(file, i) {
    return _c('div', {
      staticClass: "file-upload-outer clearfix"
    }, [(file.forOpti) ? _c('div', [_c('div', {
      staticClass: "file-upload-header clearfix"
    }, [_c('header', [_c('div', {
      staticClass: "mass-type mass-opti"
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(file.fileName))]), _vm._v(" "), _c('batch-labels', {
      attrs: {
        "fileData": file.data
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "load-xs"
    }, [(!file.complete) ? _c('pulse-loader', {
      attrs: {
        "size": '5px'
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "upload-buttons"
    }, [_c('i', {
      staticClass: "ion ion-chevron-down",
      on: {
        "click": function($event) {
          file.visible = !file.visible
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.removeFile(i)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      class: [file.visible ? 'open' : '', 'upload-contents']
    }, [_c('vue-table', {
      attrs: {
        "showEdit": false,
        "showDelete": false,
        "tableData": _vm.getRequestData(file),
        "tableTitle": 'Quotes',
        "fields": _vm.fieldsForOpti(file.fromArchive)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-outer clearfix"
    }, [(!file.complete) ? _c('div', {
      staticClass: "load-md"
    }, [_vm._v("\n              Loading"), _c('pulse-loader', {
      attrs: {
        "size": '9px'
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "drop-sm"
    }, [_c('parse-from-json', {
      attrs: {
        "disabled": !file.complete,
        "json": _vm.makeOptiSpreadsheet(file),
        "fileName": _vm.makeFileName(file)
      }
    })], 1)])]) : _c('div', [_c('div', {
      staticClass: "file-upload-header clearfix"
    }, [_c('header', [_c('div', {
      staticClass: "mass-type mass-rating"
    }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(file.fileName))]), _vm._v(" "), _c('span', {
      staticClass: "label-default label load-xs"
    }, [(!file.complete) ? _c('pulse-loader', {
      attrs: {
        "size": '5px'
      }
    }) : _vm._e()], 1), _vm._v(" "), (file.complete) ? _c('span', {
      staticClass: "label-success label"
    }, [_vm._v("Complete")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "label-default label"
    }, [_vm._v("Total " + _vm._s(file.data.length))])]), _vm._v(" "), _c('div', {
      staticClass: "upload-buttons"
    }, [_c('i', {
      staticClass: "ion ion-chevron-down",
      on: {
        "click": function($event) {
          file.visible = !file.visible
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          return _vm.removeFile(i)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      class: [file.visible ? 'open' : '', 'upload-contents']
    }, [_c('vue-table', {
      attrs: {
        "showEdit": false,
        "showDelete": false,
        "tableData": file.data,
        "tableTitle": 'Quotes',
        "fields": _vm.fieldsForRatings(file.fromArchive)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "bottom-outer clearfix"
    }, [(!file.complete) ? _c('div', {
      staticClass: "load-md"
    }, [_vm._v("\n              Loading"), _c('pulse-loader', {
      attrs: {
        "size": '9px'
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "drop-sm"
    }, [_c('parse-from-json', {
      attrs: {
        "disabled": !file.complete,
        "json": file.data,
        "fileName": file.guid
      }
    })], 1)])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h2', [_vm._v("Quote Uploads - CSV or XLSX")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Uploads")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-443a9eb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteUploads.vue
// module id = 2169
// module chunks = 1